import React from "react";
import App from "../App";
import Sucesso from "../pages/Sucesso";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "../NotFound";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:hash" element={<App />} />
        <Route path="/sucesso" element={<Sucesso />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
